import React from 'react';
import {OperatorHardwareInsight} from "types/OperatorInsights";
import {ChartData, ChartOptions} from "chart.js";
import {Pie as PieChart} from "react-chartjs-2";

// Types ----

type DailyInteractionsChartProps = {
    data: OperatorHardwareInsight
}

// Component ----

function DailyInteractionsChart({data}: DailyInteractionsChartProps) {

    const chartData: ChartData<'pie', any> = {
        labels: data.summary.daily_hardware_interactions.map(day => day.day),
        datasets: [{
            label: "Interactions per day",
            backgroundColor: [
                'rgba(255, 99, 132, 0.2)',
                'rgba(54, 162, 235, 0.2)',
                'rgba(255, 206, 86, 0.2)',
                'rgba(75, 192, 192, 0.2)',
                'rgba(153, 102, 255, 0.2)',
                'rgba(255, 159, 64, 0.2)',
                'rgb(216, 119, 236, 0.2)',
            ],
            borderColor: [
                'rgba(255, 99, 132, 1)',
                'rgba(54, 162, 235, 1)',
                'rgba(255, 206, 86, 1)',
                'rgba(75, 192, 192, 1)',
                'rgba(153, 102, 255, 1)',
                'rgba(255, 159, 64, 1)',
                'rgb(216, 119, 236, 1)',
            ],
            borderWidth: 1,
            data: data.summary.daily_hardware_interactions.map(day => day.total_interactions)
        }],
    }

    const chartOptions: ChartOptions<'pie'> = {
        plugins: {
            legend: {
                display: true,
            }
        },
        radius: '90%',
        maintainAspectRatio: false
    }

    return (
        <PieChart data={chartData} options={chartOptions} />
    );
}

export default DailyInteractionsChart;